import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { CustomerUser } from '@src/app/models/customeruser';

@Injectable({
  providedIn: 'root'
})
export class CustomerusereditService {

  constructor(private http:HttpClient) { }

  editCustomerUser(customerUser:CustomerUser){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.put<string>(environment.apiUrl+
      '/organization/'+SessionHelper.getChoosenOrg()+'/customer/'+
      customerUser.customerId+
      '/user/'
      +customerUser.userId,JSON.stringify(customerUser),httpOptions);
  }
}
